<template>
  <div class="sitemap__wrap layout">
    <IconTitle :config="{title: '网站地图'}" />
    <div class="m-sitemap__content">
      <ul class="m-sitemap__category-list ms-row">
        <template v-for="(nav1st, idx1st) in links">
          <li class="col-xs-6 col-sm-3 m-sitemap__category-list-item-container m-sitemap__category-list-item-container-separator" :key="`Nav-#1-${idx1st}`">
            <Xink class="m-sitemap__link m-sitemap__link--top-level m-sitemap__category-list-item" :action="nav1st.action">{{nav1st.text}}</Xink>
            <template v-if="Array.isArray(nav1st.children) && nav1st.children.length">
              <ul class="m-sitemap__category-list--secondary m-sitemap__category-list-item">
                <li v-for="(nav2rd, idx2rd) in nav1st.children" :key="`Nav-#1-${idx1st}-#2-${idx2rd}`">
                  <Xink class="m-sitemap__link m-sitemap__link--secondary" :action="nav2rd.action">{{nav2rd.text}}</Xink>
                  <template v-if="Array.isArray(nav2rd.children) && nav2rd.children.length">
                    <ul class="m-sitemap__category-list--third">
                      <li v-for="(nav3th, idx3th) in nav2rd.children" :key="`Nav-#1-${idx1st}-#2-${idx2rd}-#3-${idx3th}`">
                        <Xink class="m-sitemap__link m-sitemap__link--third" :action="nav3th.action">{{nav3th.text}}</Xink>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </template>
          </li>
        </template>
        <li class="col-xs-12 m-sitemap__pages-list-separator" v-if="false"></li>
      </ul>
      <!--  -->
      <ul class="m-sitemap__pages-list ms-row" v-if="false">
        <li class="col-xs-12 col-sm-3 m-sitemap__pages-list-item">
          <a href="https://www.sisley-paris.com/fr-FR/le-magazine-by-sisley/" class="m-sitemap__link m-sitemap__link--forth">希思黎杂志</a>
        </li>
        <li class="col-xs-12 m-sitemap__pages-list-separator"></li>
        <li class="col-xs-12 col-sm-3 m-sitemap__pages-list-item">
        <a href="https://www.sisley-paris.com/fr-FR/parfum/" class="m-sitemap__link m-sitemap__link--forth">香水</a>
        </li>
        <li class="col-xs-12 col-sm-3 m-sitemap__pages-list-item">
        <a href="https://www.sisley-paris.com/fr-FR/tout-voir/" class="m-sitemap__link m-sitemap__link--forth">查看全部</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconTitle from "@/components/IconTitle";
import Xink from "@/components/Xink";

export default {
  name: "SiteMap",
  components: { IconTitle, Xink },
  computed: {
    links() {
      let { navs__primary, navs__secondary } = this.$store.state;
      if (Array.isArray(navs__primary) && navs__primary.length && Array.isArray(navs__secondary) && navs__secondary.length) {
        return [...navs__primary, ...navs__secondary];
      }
      return [];
    }
  }
}
</script>

<style lang="scss" scoped>
  .sitemap__wrap { padding-top: 3.5625rem; }
  .m-sitemap__content { padding: 2.1875rem 0 5.375rem; }
  .m-sitemap__category-list { padding: 0 .5rem; margin: 0; }
  .m-sitemap__category-list-item-container { padding: 0; }
  .m-sitemap__link { font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; text-decoration: none; text-transform: lowercase; display: block; }
  .m-sitemap__link--top-level { width: 100%; font-size: 1.5625rem; padding-top: 1.5625rem; padding-bottom: 1.5625rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .m-sitemap__category-list-item { padding-right: 1.25rem; }
  .m-sitemap__category-list-item-container-separator .m-sitemap__link--top-level { border-bottom: .0625rem solid #cacaca; }
  //
  .m-sitemap__category-list--secondary { padding-top: 2rem; }
  .m-sitemap__link--secondary { font-size: 1rem; padding-bottom: .375rem; }
  // 
  .m-sitemap__category-list--third { padding-bottom: 2rem; }
  .m-sitemap__link--third { color: #575757; font-size: .8125rem; }
  // 
  .m-sitemap__pages-list-separator { border-bottom: .0625rem solid #cacaca; }
  .m-sitemap__pages-list { padding: 0 .5rem; margin: 0; }
  .m-sitemap__pages-list-item { padding: 1.5625rem 0; }
  .m-sitemap__link--forth {
    font-size: 1.5625rem;
  }

  @media screen and (min-width: 48em) {
    .m-sitemap__content { padding: 2.8125rem 0 4.6875rem; }
    .m-sitemap__category-list { padding: 0; }
    .m-sitemap__pages-list { padding: 0; }
    .m-sitemap__pages-list-item { padding: 1.5625rem 1.75rem 1.5625rem 0; }
  }

  @media screen and (min-width: 48em) {
    .sitemap__wrap { padding-top: 6.25rem; }
  }
</style>